export interface TreeNode {
  readonly text: string;
  readonly children?: readonly TreeNode[];
}

export const treeStructure: TreeNode = {
  text: "",
  children: [
    {
      text: "General",
      children: [
        { text: "Company Name" },
        { text: "Exchange" },
        { text: "Quote time" },
      ],
    },
    {
      text: "Stock Price",
      children: [
        {
          text: 'Intraday',
          children: [
            {
              text: 'Last Price'
            },
            {
              text: 'Open'
            },
            {
              text: 'High'
            },
            {
              text: 'Low'
            },
            {
              text: 'Change'
            },
            {
              text: 'Change%'
            },
            {
              text: 'Change Since Open'
            },
            {
              text: 'Change Since Open%'
            },
            {
              text: 'Stock Volume'
            },
            {
              text: 'CumulativePrice'
            },
            {
              text: 'CumulativeValue'
            },
            {
              text: 'VWAP'
            },
            {
              text: 'Ask'
            },
            {
              text: 'Ask Size'
            },
            {
              text: 'Bid Size'
            },
            {
              text: 'Bid'
            }
          ]
        },
        {
          text: 'Previous day',
          children: [
            {
              text: 'Prev. Close'
            },
            {
              text: 'Prev. Day Chg'
            },
            {
              text: 'Prev. Day % Chg'
            },
            {
              text: 'Prev. Day Stock Vol.'
            },
            {
              text: 'Prev. VWAP'
            },
            {
              text: 'Prev. Closing Ask'
            },
            {
              text: 'Prev. Closing Ask Size'
            },
            {
              text: 'Prev. Closing Bid'
            },
            {
              text: 'Prev. Closing Bid Size'
            }
          ]
        },
        {
          text: '52 week',
          children: [
            {
              text: '52 wk High date'
            },
            {
              text: '52 wk High price'
            },
            {
              text: '52 wk Low date'
            },
            {
              text: '52 wk Low price'
            },
          ]
        }
      ]
    },
    {
      text: "Implied Volatility",
      children: [
        {
          text: "Comparison",
          children: [
            {
              text: 'Opening IVX 30/HV20'
            },
            {
              text: 'Call / Put IVX 1m ratio (%)'
            }
          ]
        },
        {
          text: "Term 7",
          children: [
            {
              text: 'IVX 7 (%)'
            },
            {
              text: 'IVX 7 Chg'
            },
            {
              text: 'IVX 7 Chg%'
            },
            {
              text: 'IVX 7 Chg Since Open'
            },
            {
              text: 'IVX 7 Chg Since Open %'
            },
          ]
        },
        {
          text: "Term 14",
          children: [
            {
              text: 'IVX 14 (%)'
            },
            {
              text: 'IVX 14 Chg'
            },
            {
              text: 'IVX 14 Chg%'
            },
            {
              text: 'IVX 14 Chg Since Open'
            },
            {
              text: 'IVX 14 Chg Since Open %'
            },
          ]
        },
        {
          text: "Term 21",
          children: [
            {
              text: 'IVX 21 (%)'
            },
            {
              text: 'IVX 21 Chg'
            },
            {
              text: 'IVX 21 Chg%'
            },
            {
              text: 'IVX 21 Chg Since Open'
            },
            {
              text: 'IVX 21 Chg Since Open %'
            },
          ]
        },
        {
          text: "Term 30",
          children: [
            {
              text: 'IVX 30 (%)'
            },
            {
              text: 'IVX 30 Chg'
            },
            {
              text: 'IVX 30 Chg%'
            },
            {
              text: 'IVX 30 Chg Since Open'
            },
            {
              text: 'IVX 30 Chg Since Open %'
            },
            {
              text: 'IVP 30 (%)'
            },
            {
              text: 'IVR 30 (%)'
            },
            {
              text: 'Prev. Closing IVX 30 (%)'
            },
            {
              text: 'Prev. Day IVX 30 Chg'
            },
            {
              text: 'Prev. Day IVX 30 Chg%'
            },
            {
              text: 'IVX30 H/L (%)'
            },
            {
              text: 'IVX30 H/L date'
            },
          ]
        },
        {
          text: "Term 60",
          children: [
            {
              text: 'IVX 60 (%)'
            },
            {
              text: 'IVX 60 Chg'
            },
            {
              text: 'IVX 60 Chg%'
            },
            {
              text: 'IVX 60 Chg Since Open'
            },
            {
              text: 'IVX 60 Chg Since Open %'
            },
            {
              text: 'IVP 60 (%)'
            },
            {
              text: 'IVR 60 (%)'
            },
            {
              text: 'Prev. Closing IVX 60 (%)'
            },
            {
              text: 'Prev. Day IVX 60 Chg'
            },
            {
              text: 'Prev. Day IVX 60 Chg%'
            },
            {
              text: 'IVX60 H/L (%)'
            },
            {
              text: 'IVX60 H/L date'
            },
          ]
        },
        {
          text: "Term 90",
          children: [
            {
              text: 'IVX 90 (%)'
            },
            {
              text: 'IVX 90 Chg'
            },
            {
              text: 'IVX 90 Chg%'
            },
            {
              text: 'IVX 90 Chg Since Open'
            },
            {
              text: 'IVX 90 Chg Since Open %'
            },
            {
              text: 'IVP 90 (%)'
            },
            {
              text: 'IVR 90 (%)'
            },
            {
              text: 'Prev. Closing IVX 90 (%)'
            },
            {
              text: 'Prev. Day IVX 90 Chg'
            },
            {
              text: 'Prev. Day IVX 90 Chg%'
            },
            {
              text: 'IVX90 H/L (%)'
            },
            {
              text: 'IVX90 H/L date'
            },
          ]
        },
        {
          text: "Term 120",
          children: [
            {
              text: 'IVX 120 (%)'
            },
            {
              text: 'IVX 120 Chg'
            },
            {
              text: 'IVX 120 Chg%'
            },
            {
              text: 'IVX 120 Chg Since Open'
            },
            {
              text: 'IVX 120 Chg Since Open %'
            },
            {
              text: 'IVP 120 (%)'
            },
            {
              text: 'IVR 120 (%)'
            },
            {
              text: 'Prev. Closing IVX 120 (%)'
            },
            {
              text: 'Prev. Day IVX 120 Chg'
            },
            {
              text: 'Prev. Day IVX 120 Chg%'
            },
            {
              text: 'IVX120 H/L (%)'
            },
            {
              text: 'IVX120 H/L date'
            },
          ]
        },
        {
          text: "Term 150",
          children: [
            {
              text: 'IVX 150 (%)'
            },
            {
              text: 'IVX 150 Chg'
            },
            {
              text: 'IVX 150 Chg%'
            },
            {
              text: 'IVX 150 Chg Since Open'
            },
            {
              text: 'IVX 150 Chg Since Open %'
            },
            {
              text: 'IVP 150 (%)'
            },
            {
              text: 'IVR 150 (%)'
            },
            {
              text: 'Prev. Closing IVX 150 (%)'
            },
            {
              text: 'Prev. Day IVX 150 Chg'
            },
            {
              text: 'Prev. Day IVX 150 Chg%'
            },
            {
              text: 'IVX150 H/L (%)'
            },
            {
              text: 'IVX150 H/L date'
            },
          ]
        },
        {
          text: "Term 180",
          children: [
            {
              text: 'IVX 180 (%)'
            },
            {
              text: 'IVX 180 Chg'
            },
            {
              text: 'IVX 180 Chg%'
            },
            {
              text: 'IVX 180 Chg Since Open'
            },
            {
              text: 'IVX 180 Chg Since Open %'
            },
            {
              text: 'IVP 180 (%)'
            },
            {
              text: 'IVR 180 (%)'
            },
            {
              text: 'Prev. Closing IVX 180 (%)'
            },
            {
              text: 'Prev. Day IVX 180 Chg'
            },
            {
              text: 'Prev. Day IVX 180 Chg%'
            },
            {
              text: 'IVX180 H/L (%)'
            },
            {
              text: 'IVX180 H/L date'
            },
          ]
        },
        {
          text: "Term 270",
          children: [
            {
              text: 'IVX 270 (%)'
            },
            {
              text: 'IVX 270 Chg'
            },
            {
              text: 'IVX 270 Chg%'
            },
            {
              text: 'IVX 270 Chg Since Open'
            },
            {
              text: 'IVX 270 Chg Since Open %'
            },
          ]
        },
        {
          text: "Term 360",
          children: [
            {
              text: 'IVX 360 (%)'
            },
            {
              text: 'IVX 360 Chg'
            },
            {
              text: 'IVX 360 Chg%'
            },
            {
              text: 'IVX 360 Chg Since Open'
            },
            {
              text: 'IVX 360 Chg Since Open %'
            },
          ]
        },
        {
          text: "Term 720",
          children: [
            {
              text: 'IVX 720 (%)'
            },
            {
              text: 'IVX 720 Chg'
            },
            {
              text: 'IVX 720 Chg%'
            },
            {
              text: 'IVX 720 Chg Since Open'
            },
            {
              text: 'IVX 720 Chg Since Open %'
            },
          ]
        },
        {
          text: "Term 1080",
          children: [
            {
              text: 'IVX 1080 (%)'
            },
            {
              text: 'IVX 1080 Chg'
            },
            {
              text: 'IVX 1080 Chg%'
            },
            {
              text: 'IVX 1080 Chg Since Open'
            },
            {
              text: 'IVX 1080 Chg Since Open %'
            },
          ]
        },
        {
          text: 'Skew term 30',
          children: [
            {
              text: '10 delta skew (30 days)'
            },
            // {
            //   text: '25 delta skew (30 days)'
            // }
          ]
        }
      ],
    },
    {
      text: 'Historical Volatility',
      children: [
        {
          text: '10 days',
          children: [
            {
              text: 'HV 10 (%)'
            },
            {
              text: 'HVP 10 (%)'
            }
          ]
        },
        {
          text: '20 days',
          children: [
            {
              text: 'HV 20 (%)'
            },
            {
              text: 'HVP 20 (%)'
            }
          ]
        },
        {
          text: '30 days',
          children: [
            {
              text: 'HV 30 (%)'
            },
            {
              text: 'HVP 30 (%)'
            },
            {
              text: 'HV HL 30'
            }
          ]
        },
        {
          text: '60 days',
          children: [
            {
              text: 'HV 60 (%)'
            },
            {
              text: 'HVP 60 (%)'
            },
            {
              text: 'HV HL 60'
            }
          ]
        },
        {
          text: '90 days',
          children: [
            {
              text: 'HV 90 (%)'
            },
            {
              text: 'HVP 90 (%)'
            },
            {
              text: 'HV HL 90'
            }
          ]
        },
        {
          text: '120 days',
          children: [
            {
              text: 'HV 120 (%)'
            },
            {
              text: 'HVP 120 (%)'
            },
            {
              text: 'HV HL 120'
            }
          ]
        },
        {
          text: '150 days',
          children: [
            {
              text: 'HV 150 (%)'
            },
            {
              text: 'HVP 150 (%)'
            },
            {
              text: 'HV HL 150'
            }
          ]
        },
        {
          text: '180 days',
          children: [
            {
              text: 'HV 180 (%)'
            },
            {
              text: 'HVP 180 (%)'
            },
            {
              text: 'HV HL 180'
            }
          ]
        },
      ]
    },
    {
      text: 'Options',
      children: [
        {
          text: 'Option Volume',
          children: [
            {
              text: 'Opt Vol',
            },
            {
              text: 'Opt Vol Call',
            },
            {
              text: 'Opt Vol Put',
            },
            {
              text: 'Call/put volume ratio',
            },
            {
              text: 'Put/call volume ratio',
            },
            {
              text: 'Prev. Day OV',
            },
            {
              text: 'Prev. Day Call OV',
            },
            {
              text: 'Prev. Day Put OV',
            },
            {
              text: 'Prev. Call/Put Ratio',
            },
            {
              text: 'Prev. Put/call Ratio',
            },
            {
              text: 'Avg Opt Vol 1WK',
            },
            {
              text: 'Avg Opt Vol 1MO',
            }
          ]
        },
        {
          text: 'Open Interest',
          children: [
            {
              text: 'OI at Close'
            },
            {
              text: 'OI Call at Close'
            },
            {
              text: 'OI Put at Close'
            },
            {
              text: 'Avg Opt OI 1WK'
            },
            {
              text: 'Avg Opt OI 1MO'
            },
          ]
        }
      ]
    },
    {
      text: 'Fundamental',
      children: [
        {
          text: 'Industry'
        },
        {
          text: 'Market Cap'
        },
        {
          text: 'Dividend Amount'
        },
        {
          text: 'Dividend Date'
        },
        {
          text: 'Dividend Frequency'
        },
        {
          text: 'Dividend Yield'
        },
        {
          text: 'Shares outstanding'
        },
        {
          text: 'Earnings Per Share'
        },
        {
          text: 'Price/Earnings ratio'
        },
      ]
    },
    {
      text: 'Correlations',
      children: [
        {
          text: 'Corr10D (%)'
        },
        {
          text: 'Corr20D (%)'
        },
        {
          text: 'Corr30D (%)'
        },
        {
          text: 'Corr60D (%)'
        },
        {
          text: 'Corr90D (%)'
        },
        {
          text: 'Corr120D (%)'
        },
        {
          text: 'Corr150D (%)'
        },
        {
          text: 'Corr180D (%)'
        },
      ]
    },
    {
      text: 'Beta',
      children: [
        {
          text: 'Beta 10D'
        },
        {
          text: 'Beta 20D'
        },
        {
          text: 'Beta 30D'
        },
        {
          text: 'Beta 60D'
        },
        {
          text: 'Beta 90D'
        },
        {
          text: 'Beta 120D'
        },
        {
          text: 'Beta 150D'
        },
        {
          text: 'Beta 180D'
        },
      ]
    }
  ],
};
